import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Box,
    Button,
    Grid,
    IconButton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
    ReactHookFormSelect2,
} from 'common/components/form/bootstrap';
import { getPhoneCodeOptions } from 'common/utils/helpers';

const ReactHookFormArrayPhones = ({ codes = [], control, isDisabled }) => {
    const { t } = useTranslation();
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'telephones',
    });
    return (
        <>
            {fields.length > 0 && (
                <Grid size={18}>
                    {fields.map((item, i) => (
                        <Grid container key={item.id}>
                            <Grid size={18}>
                                <Typography variant="body2" fontWeight="bold">
                                    {t('Telephone')} {i + 1}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 8, sm: 6, md: 4 }}>
                                <ReactHookFormSelect2
                                    control={control}
                                    disabled={isDisabled}
                                    label={t('Phone code')}
                                    name={`telephones.${i}.phone_key`}
                                    options={[
                                        {
                                            label: '',
                                            options: getPhoneCodeOptions(codes),
                                        },
                                    ]}
                                    required={true}
                                    sx={{ md: 0 }}
                                />
                            </Grid>

                            <Grid size={{ xs: 10, sm: 12, md: 10 }}>
                                <ReactHookFormInput
                                    control={control}
                                    disabled={isDisabled}
                                    label={t('Phone number')}
                                    name={`telephones.${i}.telephone`}
                                    sx={{ md: 0 }}
                                />
                            </Grid>

                            <Grid size={{ xs: 18, md: 4 }}>
                                <ReactHookFormInput
                                    control={control}
                                    disabled={isDisabled}
                                    label={t('Extension')}
                                    name={`telephones.${i}.extension`}
                                    sx={{ md: 0 }}
                                />
                            </Grid>

                            <Grid size={18}>
                                <Box
                                    sx={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        gap: '5px',
                                    }}
                                >
                                    <ReactHookFormSelect
                                        control={control}
                                        disabled={isDisabled}
                                        label={t('Type')}
                                        name={`telephones.${i}.phone_type`}
                                        options={[
                                            {
                                                disabled: true,
                                                label: t('Select'),
                                                value: '',
                                            },
                                            {
                                                label: t('Mobile'),
                                                value: '0',
                                            },
                                            {
                                                label: t('Office'),
                                                value: '1',
                                            },
                                            {
                                                label: t('Home'),
                                                value: '2',
                                            },
                                            {
                                                label: t('Other'),
                                                value: '3',
                                            },
                                        ]}
                                    />
                                    <IconButton
                                        onClick={() => remove(i)}
                                        sx={{ mb: 2 }}
                                    >
                                        <DeleteIcon fontSize="medium" />
                                    </IconButton>
                                </Box>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            )}

            <Grid size={18}>
                <Button
                    disabled={isDisabled}
                    endIcon={<AddIcon />}
                    onClick={() =>
                        append({
                            extension: '',
                            phone_key: '+57',
                            phone_type: 0,
                            telephone: '',
                        })
                    }
                    sx={{ width: { md: 'auto', xs: '100%' } }}
                    type="button"
                    variant="outlined"
                >
                    {t('Add phone')}
                </Button>
            </Grid>
        </>
    );
};

ReactHookFormArrayPhones.propTypes = {
    codes: PropTypes.array,
    control: PropTypes.object,
    isDisabled: PropTypes.bool,
};

export default ReactHookFormArrayPhones;
